
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/[franchiseSlug]/[year]/[personSlug]",
      function () {
        return require("private-next-pages/ranking/[franchiseSlug]/[year]/[personSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/[franchiseSlug]/[year]/[personSlug]"])
      });
    }
  